import React, { PureComponent } from 'react';
import Orbit from './_internal/Orbit';

import './orbitFeature.scss';

export default class OrbitFeature extends PureComponent {
    render() {
        const { heading, description, stars } = this.props;

        return (
            <section className="marketing-container__max-width">
                <div className="eds-g-group eds-align--center eds-l-sn-pad-bot-4 eds-l-sm-pad-bot-4 orbit-wrapper">
                    <div className="eds-g-cell eds-g-cell-12-12 eds-g-cell-sw-4-12 eds-l-pad-hor-4">
                        <h2 className="eds-text-hm eds-text-color--grey-900 eds-l-mar-bot-4">
                            {heading}
                        </h2>
                        <p className="eds-text-bl eds-text-color--grey-600">
                            {description}
                        </p>
                    </div>
                    <Orbit stars={stars} />
                </div>
            </section>
        );
    }
}
